import PropTypes from 'prop-types';
import { Link } from 'react-router';

import css from 'styles/components/checkout/melody/sectionCancel.scss';

const SectionCancel = ({ labelledby, to, showLink, onClickEvent }, { testId = f => f }) => (
  !!showLink && <div className={css.wrapper}>
    <Link
      aria-labelledby={labelledby}
      className={css.link}
      to={to}
      onClick={onClickEvent}
      data-test-id={testId('cancelLink')}>Cancel</Link>
  </div>
);

SectionCancel.contextTypes = {
  testId: PropTypes.func
};

export default SectionCancel;
